import styled from 'styled-components';
import { pxToRem } from 'utils/scss';

export const TermsAndConditionsTitle = styled.div`
  padding-top:${pxToRem('70px')}
  color: ${props => props.theme.colors.white};
  display: flex;
  justify-content: center;
`;
